// Normalización de fotos de hallazgo antes de subir/persistir.
// La foto entra ya CUADRADA desde antd-img-crop; esto solo acota el lado máximo
// (para que el PDF no pese de más) y re-encoda jpeg comprimido.

// Cálculo puro del tamaño destino (nunca agranda). Testeable sin canvas.
export function computeScaledSize(w, h, maxSide) {
  const scale = Math.min(1, maxSide / Math.max(w, h));
  return { w: Math.round(w * scale), h: Math.round(h * scale) };
}

// Reescala una imagen a lado máximo `maxSide` y la re-encoda jpeg `quality`.
// Devuelve un File nuevo. Usa canvas (solo navegador; en tests se mockea).
export async function downscaleImage(file, { maxSide = 1200, quality = 0.8 } = {}) {
  const bitmap = await createImageBitmap(file);
  const { w, h } = computeScaledSize(bitmap.width, bitmap.height, maxSide);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  canvas.getContext('2d').drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
  const name = file.name.replace(/\.\w+$/, '') + '.jpg';
  return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified });
}
